
import { mapState } from 'vuex'
import CtPhoneCode from '@/components/phoneCode/index.vue'
import captcha from '@/utils/captcha.js'

export default {
  components: {
    CtPhoneCode,
  },
  model: {
    prop: 'modalValue',
    event: 'updateModalValue',
  },
  props: {
    modalValue: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    waybillNo: {
      type: String,
      default: '',
    },
    timeZone: {
      type: String,
      default: '',
    },
    businessCode: {
      type: String,
      default: '1',
    },
    isNoShow: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: () => {},
    },
    allowClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        code: '',
      },
      loading: false,
      showSlider: false,
      style: { top: '30%' },
      rules: {
        code: [
          {
            required: true,
            pattern: /^\d{4}$/,
            message: this.$t('serviceSupport.clearanceService.inputCPhone'),
            trigger: ['change', 'blur'],
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      isMobile: (state) => state.isMobile,
    }),
    visible: {
      get() {
        return this.modalValue
      },
      set(v) {
        this.$emit('updateModalValue', v)
      },
    },
    disabled() {
      return !this.form.code || this.form.code.length < 4
    },
  },
  created() {
    // console.log('site', this.$route.params.site); 
    if (process.client) {
      captcha.init({
        lang: this.locale,
        app: this,
        cancelCallback: this.cancelCallback,
      })
    }
  },
  methods: {
    showAndHide() {
      if (!this.isNoShow) {
        this.visible = !this.visible
        this.$emit('customClick', true)
      }
    },
    cancel() {
      this.reset()
      this.visible = false
    },
    reset() {
      this.form.code = ''
      this.loading = false
    },
    getContainer() {
      return this.$refs.decode
    },
    cancelCallback() {
      this.$set(this, 'loading', false)
    },
    filter(object) {
      const temp = {}
      for (const i in object) {
        if (object[i]) temp[i] = object[i]
      }
      return temp
    },
    getSlideCaptch() {
      this.$refs.form.validate(async (valid) => {
        if (valid && !this.loading) {
          this.loading = true
          const params = this.filter({
            mobileNoLast4: this.form.code,
            waybillNo: this.waybillNo,
            timeZone: this.timeZone,
            phoneNumber: this.phoneNumber,
            businessCode: this.businessCode,
          })
          try {
            const showSlider =
              (await this.$API.support.getShowSlider(params)) || false
            if (showSlider) {
              const cap = await captcha.verify()
              this.callback && (await this.callback(params, cap))
            } else {
              this.callback && (await this.callback(params))
            }
            this.reset()
          } catch (error) {
            console.error('Phone verification failed:', error)
            this.$message.error(this.$t('common.http.networkError'))
            this.loading = false
          }
        }
      })
    }
  }
}
